/* ==========================================================================
   CarouselRxjs
   ========================================================================== */

/* Modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');

const prototype = require('./prototype');
const config = require('./config');

/**
 * Client/browser JS
 * @param {string} selector String selector
 * @param {object} config Configuration object to create the carousel instance
 */
module.exports = function CarouselClient(selector = '[data-component="CarouselRxjs"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Create the instance based on prototype */
        const instance = Object.create(prototype);

        /* Element reference */
        instance.element = document.querySelector(selector);

        /* Id reference */
        instance.id = randomId(randomId('carousel-rxjs'));

        /* Hooks */
        instance.hooks = {
            swiper: instance.element.querySelector('[data-swiper]')
        };

        /* Config */
        instance.config = {
            ...config(),
            ...configuration,
            ...(function getConfig() {
                if (!instance.element.dataset.config) return '';

                const result = JSON.parse(instance.element.dataset.config);
                instance.element.dataset.config = '';

                return result;
            })()
        };

        /* Init */
        instance.init();

        return instance;
    }
};
